import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FrameToComeService } from '@app/core/services';

@Component({
  selector: 'ecp-generated-label',
  templateUrl: './generated-label.component.html',
  styleUrls: ['./generated-label.component.scss']
})
export class GeneratedLabelComponent implements OnInit {
  generating:boolean = false;
  theme = 'one-portal';
  generatedLabel: any;
  constructor(
    private dialogRef: MatDialogRef<GeneratedLabelComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private frameToComeService: FrameToComeService,
  ) {
    this.generating = true;
    this.frameToComeService.generateShippingLabel(data).subscribe((res:any) => {
      this.generatedLabel = res;
      this.generating = false;
    });
  }

  ngOnInit(): void {
  }
  printLabel(){
    let imageFile = 'data:image/png;base64,'+ this.generatedLabel.labelBinary;
    const newWindow = window.open();
    newWindow.document.write('<img src="' + imageFile + '" style="transform:rotate(90deg);margin-top:30%;width:100%" onload="window.print();window.close();" />');
    newWindow.document.close();
    this.dialogRef.close(true);
  }

}
